import { Box } from "@storyofams/react-ui";
import { useQuery } from "react-query";
import { ProductCardSmall } from "~components/common/ProductCard/ProductCardSmall";
import { ProductCard } from "~components/product/components";
import { shopifySdk } from "~lib/shopify/client";

export const Product = ({ content, size }) => {
  const { data: product } = useQuery(
    ["product", content],
    () => shopifySdk.productsByIds({ ids: content.product.items[0].id }),
    { enabled: Boolean(content) }
  );
  if (size === 1)
    return (
      <>
        <Box width={"50%"} display={["block", "none"]}>
          <Box>
            <ProductCard {...product?.nodes[0]} />
          </Box>
        </Box>
        <Box width={["248px"]} display={["none", "block"]}>
          <Box
            border="1px solid grey200"
            borderRadius="md"
            p={["15px", size === 3 ? "15px" : "25px"]}
          >
            <ProductCardSmall {...product?.nodes[0]} size={size} />
          </Box>
        </Box>
      </>
    );
  if (product)
    return (
      <Box width={["248px"]}>
        <Box
          border="1px solid grey200"
          borderRadius="md"
          p={["15px", size === 3 ? "15px" : "25px"]}
        >
          <ProductCardSmall {...product?.nodes[0]} size={size} />
        </Box>
      </Box>
    );
  return null;
};
